"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.I9Status = void 0;
exports.instanceOfI9Status = instanceOfI9Status;
exports.I9StatusFromJSON = I9StatusFromJSON;
exports.I9StatusFromJSONTyped = I9StatusFromJSONTyped;
exports.I9StatusToJSON = I9StatusToJSON;
exports.I9StatusToJSONTyped = I9StatusToJSONTyped;
/**
 *
 * @export
 */
exports.I9Status = {
    None: 'NONE',
    Uploaded: 'UPLOADED',
    Started: 'STARTED',
    Section1Completed: 'SECTION_1_COMPLETED',
    AuthorizedRepresentativeContacted: 'AUTHORIZED_REPRESENTATIVE_CONTACTED',
    Section2Completed: 'SECTION_2_COMPLETED'
};
function instanceOfI9Status(value) {
    for (const key in exports.I9Status) {
        if (Object.prototype.hasOwnProperty.call(exports.I9Status, key)) {
            if (exports.I9Status[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function I9StatusFromJSON(json) {
    return I9StatusFromJSONTyped(json, false);
}
function I9StatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function I9StatusToJSON(value) {
    return value;
}
function I9StatusToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=I9Status.js.map